import React, { createContext, useState } from 'react'

export const Context = createContext()

const Provider = ({ children }) => {
    const [isAuth, setIsAuth] = useState(() => {
        return localStorage.getItem('user')
    })

    const value = {
        isAuth,
        activateAuth: user => {            
            localStorage.setItem('user', user)
            setIsAuth(true)
        },
        removeAuth: () => {
            localStorage.removeItem('user')
            setIsAuth(false)
        } 
    }

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    )
}

export default {
  Provider,
  Consumer: Context.Consumer
}